export const swapArr = (index: number, destIndex: number, arr: any[]) => {
  const [item] = arr.splice(index, 1);
  arr.splice(destIndex, 0, item);
};
